<frog-landing-toolbar></frog-landing-toolbar>
<div class="root">
    <section class="flex align-center justify-space-evenly jumbotron">
        <div class="flex column">
            <div class="flex row align-center justify-center">
                <div>
                    <h1>FrogEye Pricing</h1>
                    <div>
                        <span>Monthly &nbsp;</span>
                        <mat-slide-toggle color="primary" [(ngModel)]="payAnnually">
                            Annually
                        </mat-slide-toggle>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="flex align-center justify-space-evenly jumbotron">
        <div class="flex justify-space-evenly plans">
            <mat-card appearance="outlined">
                <mat-card-header>
                    <mat-card-title>
                        <h1>Free</h1>
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <h1 class="price">$0</h1>
                    <div class="sub-price">per user, per {{ payAnnually ? "year" : "month" }}</div>
                    <ng-container *ngIf="isAuthenticated$ | async; else logged_out">
                        <span>This is your current plan</span>
                    </ng-container>
                    <ng-template #logged_out>
                        <button mat-flat-button color="primary" (click)="login(false)">
                            Get Started
                        </button>
                    </ng-template>
                    <mat-list>
                        <mat-list-item>
                            <mat-icon matListItemIcon>check</mat-icon>
                            3 Free Users
                        </mat-list-item>
                        <mat-list-item>
                            <mat-icon matListItemIcon>check</mat-icon>
                            1gb Storage
                        </mat-list-item>
                        <mat-list-item>
                            <mat-icon matListItemIcon>check</mat-icon>
                            20 Uploads per week
                        </mat-list-item>
                    </mat-list>
                </mat-card-content>
            </mat-card>

            <mat-card appearance="outlined">
                <mat-card-header class="studio">
                    <mat-card-title>
                        <h1>Studio</h1>
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <h1 class="price">${{ payAnnually ? 120 : 12 }}</h1>
                    <div class="sub-price">per user, per {{ payAnnually ? "year" : "month" }}</div>
                    <ng-container *ngIf="isAuthenticated$ | async; else studio_logged_out">
                        <button mat-flat-button color="primary" routerLink="/upgrade">
                            Upgrade Now
                        </button>
                    </ng-container>
                    <ng-template #studio_logged_out>
                        <button mat-flat-button color="primary" (click)="login(false)">
                            Get Started
                        </button>
                    </ng-template>
                    <div class="key-features">
                        <mat-list>
                            <mat-list-item>
                                <mat-icon matListItemIcon>check</mat-icon>
                                50GB of Storage
                            </mat-list-item>
                            <mat-list-item>
                                <mat-icon matListItemIcon>check</mat-icon>
                                Unlimited uploads
                            </mat-list-item>
                            <mat-list-item>
                                <mat-icon matListItemIcon>check</mat-icon>
                                Discord Support
                            </mat-list-item>
                        </mat-list>
                    </div>
                </mat-card-content>
            </mat-card>

            <mat-card appearance="outlined">
                <mat-card-header class="enterprise">
                    <mat-card-title>
                        <h1>Enterprise</h1>
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <h1 class="price">
                        <mat-icon>perm_phone_msg</mat-icon>
                    </h1>
                    <div class="sub-price">&nbsp;</div>
                    <button mat-flat-button color="primary" routerLink="/contact">
                        Contact Us
                    </button>
                    <mat-list>
                        <mat-list-item>
                            <mat-icon matListItemIcon>check</mat-icon>
                            Single Tenant Option
                        </mat-list-item>
                        <mat-list-item>
                            <mat-icon matListItemIcon>check</mat-icon>
                            On-Premises Option
                        </mat-list-item>
                        <mat-list-item>
                            <mat-icon matListItemIcon>check</mat-icon>
                            Python API
                        </mat-list-item>
                    </mat-list>
                </mat-card-content>
            </mat-card>
        </div>
    </section>

    <div class="flex row justify-space-evenly">
        <div class="flex column pricing-table">
            <div class="flex row align-center justify-space-evenly feature-block">
                <div>
                    <h1>Compare Plans</h1>
                </div>
            </div>
            <table>
                <colgroup>
                    <col />
                    <col style="width: 15%" />
                    <col style="width: 15%" />
                    <col style="width: 15%" />
                </colgroup>
                <thead>
                    <tr>
                        <th></th>
                        <th class="free">
                            <h1>Free</h1>
                        </th>
                        <th class="studio">
                            <h1>Studio</h1>
                        </th>
                        <th class="enterprise">
                            <h1>Enterprise</h1>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of PricingData">
                        <td *ngIf="row.heading; else feature" colspan="4">
                            <h2>{{ row.heading }}</h2>
                        </td>
                        <ng-template #feature>
                            <td class="feature-name">{{ row.feature }}</td>
                            <td class="feature-flag">
                                <mat-icon *ngIf="row.plans[0]" class="free">task_alt</mat-icon>
                            </td>
                            <td class="feature-flag">
                                <mat-icon *ngIf="row.plans[1]" class="studio">task_alt</mat-icon>
                            </td>
                            <td class="feature-flag">
                                <mat-icon *ngIf="row.plans[2]" class="enterprise"
                                    >task_alt</mat-icon
                                >
                            </td>
                        </ng-template>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <frog-try-block></frog-try-block>
    <frog-footer></frog-footer>
</div>
